import React from 'react';
import { Link } from 'react-router-dom';
import './Button.css'; // new CSS styling for the button

const HearingRequestButton = ({ userId }) => {
  return (
    <Link to={`/hearing-request?userId=${userId}`} className="hearing-request-button">
      HÖRSESSION Anfrage
    </Link>
  );
};

export default HearingRequestButton;